import React, { useEffect, useState } from "react";
import styles from "./products.module.css";
import { useLocation } from "react-router-dom";
import { setMetaTags, getDataFromRoutes } from "../../utils/util_functions";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { useDispatch, useSelector } from "react-redux";
import { ROUTES_CONST } from "../../utils/constants";
import Loader from "../../components/loader/loader";
import { getLoading, getProducts } from "../../services/selectors";
import Filter from "../../components/filter/filter";
import ProductsList from "../../components/products_list/products_list";


const Products = () => {

  const location = useLocation();
  const isLoading = useSelector(getLoading);
  const products = useSelector(getProducts);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  // сделать изменение списка товаром через фильтрацию
  const [actualProducts, setActualProducts] = useState([...products]);



  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);
  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {window.scrollTo({ top: 0, left: 0 })}, []);

  return (
    <main className='main main__sw main__colons ' >
      {isLoading ? <Loader /> :
        <>

          <Filter />
          <div className="main_content">
            <h1 className="title">{title}</h1>
            <ProductsList actualProducts={actualProducts} />
          </div>
        </>
      }
    </main>
  );
};

export default Products;
